import React, {useState} from 'react';

import Header from "../../../layouts/Header";
import Navbar from "../../../layouts/Navbar";
import {useNavigate} from "react-router-dom";
import {CiCalendarDate, CiLocationOn} from "react-icons/ci";
import {HiHashtag} from "react-icons/hi";
import { getStatuses, getTickets} from "../api/OrdersAPI";
import Loading from "../../../layouts/Loading";
import {showError} from "../../../utils/toastHelper";
import {AiOutlineMessage} from "react-icons/ai";

const currencyFormat = Intl.NumberFormat('en-US');

function Tickets() {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(true);
    const [tickets, setTickets] = React.useState([]);
    const [statuses, setStatuses] = React.useState([]);
    const [status, setStatus] = React.useState(null);
    const config = window.APP_CONFIG;

    React.useEffect(() => {


        const fetchTickets = async () => {

            try {
                if (!status) {

                    const sparams = {
                        count: 40,
                        page: 1,
                        list: 1,
                        orderBy: 'priority_id',
                        orderType: 'asc',
                        category: 'Tickets'
                    }
                    const result = await getStatuses(sparams);
                    setStatuses(result.data);
                    setLoading(false);
                }
                const params = {
                    count: 40,
                    page: 1,
                    list: 1,
                    orderBy: 'updated_at',
                    orderType: 'desc',
                    status_id : status
                }
                const data = await getTickets(params);
                setTickets(data.data);

            } catch (err) {
                showError( err);
            } finally {
                setLoading(false);
                setLoading2(false);
            }
        };
        fetchTickets();
        setTimeout (() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },400)

    }, [status]);

    const onSelectStatus = (event, sid,color) => {
        if(sid > 0) {
            const el = document.getElementById('groups-container');
            // el.scrollLeft -= 100;
            el.scrollTo({top: 0, left: el.scrollLeft - 120, behavior: 'smooth'});
        }

        var items = document.getElementsByClassName('product-group-badge');

        for (var i = 0; i < items.length; i++) {
            items[i].style.backgroundColor = '#aaa';
        }

        event.target.style.backgroundColor = color
        setStatus(sid)
    }



    if (loading) return <Loading />;

    return (
        <React.Fragment>

            <Header title='گفتگوها (پیش فاکتور)' hasBack={false} />

            <section className="container  my-3 py-5 rtl px-0   ">

                <div className="row  flex-row flex-nowrap mx-2 overflow-scroll product-group-row border-bottom pb-4"
                     id='groups-container'
                >
                    <div className="col-3 badge badge-pill mx-2 product-group-badge py-2 "
                         style={{backgroundColor: '#424242'}}
                         onClick={
                             (e) => {
                                 onSelectStatus(e, null, '#424242');

                             }
                         }
                    >
                        همه
                    </div>
                    {
                        !loading && statuses.map(status => {
                                return (
                                    <div className="col-3 badge badge-pill text-small-3 mx-2 product-group-badge py-2" key={status.id}

                                         onClick={
                                             (e) => {
                                                 onSelectStatus(e, status?.id, status?.color);

                                             }
                                         }
                                    >
                                        {status.title}
                                    </div>
                                );
                            }
                        )
                    }
                </div>

                {
                    tickets.length < 1 && loading2 &&
                    <div className="row px-0 mx-0 mt-5 pt-5">
                        <div className="col-12 text-center">
                            <div className='text-small-4 mb-4 opacity-50'>
                                در حال بارگزاری گفتگوها...
                            </div>
                            <div className="spinner-border" role="status">

                                <span className="sr-only"></span>
                            </div>
                        </div>
                    </div>
                }

                {
                    tickets.length < 1 && !loading2 &&
                    <div className="row px-0 mx-0 mt-5 pt-5">
                        <div className="col-12 text-center">
                            <div className='text-small-2 mb-4 opacity-50'>
                               گفتگویی پیدا نشد.
                            </div>

                        </div>
                    </div>
                }
                <div className="row mx-2 mb-3">
                    {
                        tickets.map (ticket => {
                            return (
                                <div className="col-12 rtl mt-3 order-row py-3 "
                                     key={ticket.id}
                                     onClick={() => navigate(`/factors/${ticket.id}`)}
                                >
                                    <div className="row py-2 ">

                                        <div className="col-9 fw-bold text-small-2 text-muted ">

                                            <div className="row">
                                                <div className="col-3">
                                                    <img src={ticket.product?.image} alt={ticket.title} width='40px'
                                                         />
                                                </div>
                                                <div className="col-9 ">

                                                    {ticket.title}
                                                    <span className='badge rounded bg-third-color mx-2'>
                                                              {ticket?.vendor?.title}
                                                        </span>
                                                </div>
                                            </div>


                                        </div>
                                        <div className="col-3 text-start  ">
                                        <div className='text-small-2 bg-success bg-opacity-10 text-center rounded '>
                                                <HiHashtag className='mx-1'/>
                                                {ticket.tracking_code}
                                            </div>
                                            <div className=' mt-3 text-center rounded bg-secondary text-small-3  bg-opacity-10' style={{color: ticket.last_status.color}}>
                                                {ticket?.last_status.title}
                                            </div>

                                        </div>
                                        <div className="col-12 mt-2 border-bottom pb-3 text-small-2 opacity-75">
                                            <AiOutlineMessage className='ms-2 text-big-2' />
                                            {ticket.last_message}
                                        </div>
                                        <div className="col-6">
                                            <div className='fw-normal text-small-3 mt-2 text-muted'>
                                                <CiCalendarDate className='ms-1' />
                                                {ticket.date}
                                            </div>
                                        </div>
                                        <div className="col-6 text-start text-secondary mt-2 text-small-2 fw-bolder">
                                            تعداد:
                                            &nbsp;
                                            {ticket.product?.count}
                                        </div>
                                    </div>
                                </div>
                            )} )
                    }
                </div>

            </section>
            <Navbar />
        </React.Fragment>
    );
}

export default Tickets;